"use client";

import { Armchair, Sofa } from "lucide-react";
import type { TherapyDirectoryFilters } from "~/lib/therapy-directory-filters";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

interface DirectoryModeTabsProps {
  filters: TherapyDirectoryFilters;
  // True only when the route itself has no individual-therapy equivalent
  // (e.g. /terapija/za-parove). Do not pass the broader isCouplesTherapy
  // here: on an ordinary specialty ?couples=1 is reached via these same
  // tabs, and hiding them once couples mode is active would trap the
  // visitor with no way back to individual therapy.
  isCouplesOnlyRoute: boolean;
  isPending: boolean;
  onUpdate: (updates: Record<string, string | undefined>) => void;
}

export default function DirectoryModeTabs({
  filters,
  isCouplesOnlyRoute,
  isPending,
  onUpdate,
}: DirectoryModeTabsProps) {
  if (isCouplesOnlyRoute) return null;

  return (
    <Select
      value={filters.couples ? "COUPLES" : "INDIVIDUAL"}
      disabled={isPending}
      onValueChange={(value) =>
        onUpdate({ couples: value === "COUPLES" ? "1" : undefined })
      }
    >
      <SelectTrigger
        aria-label="Vrsta terapije"
        className="w-full sm:w-[210px]"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="INDIVIDUAL">
          <span className="flex items-center gap-2">
            <Armchair className="size-4" aria-hidden="true" />
            Individualna terapija
          </span>
        </SelectItem>
        <SelectItem value="COUPLES">
          <span className="flex items-center gap-2">
            <Sofa className="size-4" aria-hidden="true" />
            Terapija za parove
          </span>
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
